module.exports = __webpack_public_path__ + "media/images/hold-button-0ca9fb1b0d1a86244f2d5475115e196a93acfd01fb9c01003330bb10fadf629a.svg";